/**
 * Aviso 204: chegou uma carta no correio (techspec-correio §07). O hub avisa; a carta flutuante, a linha do Mais e a
 * janela aberta escutam e releem o resumo. `chegou` diz se foi uma carta nova (a carta flutuante entra voando).
 */
const EVENTO = 'uoidle:correio';

export function avisarCorreio(chegou = true): void {
  window.dispatchEvent(new CustomEvent<boolean>(EVENTO, { detail: chegou }));
}

export function aoCorreio(fn: (chegou: boolean) => void): () => void {
  const h = (e: Event) => fn((e as CustomEvent<boolean>).detail !== false);
  window.addEventListener(EVENTO, h);
  return () => window.removeEventListener(EVENTO, h);
}
